/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveCryptoPoolRegistryLike,
  ICurveCryptoPoolRegistryLikeInterface,
} from "../ICurveCryptoPoolRegistryLike";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "get_coins",
    outputs: [
      {
        internalType: "address[2]",
        name: "",
        type: "address[2]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ICurveCryptoPoolRegistryLike__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveCryptoPoolRegistryLikeInterface {
    return new utils.Interface(_abi) as ICurveCryptoPoolRegistryLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveCryptoPoolRegistryLike {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurveCryptoPoolRegistryLike;
  }
}
